import type { Api, Cruz } from '@cruz-com/lookup'
import { encodeQuery } from '@/lib'
import { baseURL, formatFetchError, getHeader } from '../util'

export async function feedback(params: object): Promise<Api.Result<Cruz.Feedback[]>> {
  try {
    const res = await fetch(`${baseURL}/cruz/feedback?${encodeQuery(params)}`, {
      method: 'GET',
      headers: await getHeader(),
      cache: 'no-store',
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}
